import { TodoFilterState } from "features/TodoOploggSidebar/Todo/todoFilter/useTodoFilterState";
import { UserRole } from "shared/types/roles";
import { isNotNullish } from "shared/utils/objectUtils";

export const getLocalStorageRole = () =>
  localStorage.getItem("user_role") as UserRole;

export const setLocalStorageRole = (userRole: UserRole) =>
  localStorage.setItem("user_role", userRole);

export const setLocalStorageTodoFilterSettings = (
  todoFilterSettings: TodoFilterState,
) =>
  localStorage.setItem(
    "todoFilterSettings",
    JSON.stringify(todoFilterSettings),
  );

export const getLocalStorageTodoFilterSettings = (): TodoFilterState =>
  JSON.parse(localStorage.getItem("todoFilterSettings") ?? "null");

export const setLocalStorageOploggTodoTabsSettings = (
  oploggTodoTabSettings: string[],
) =>
  localStorage.setItem(
    "oploggTodoTabsSettings",
    JSON.stringify(oploggTodoTabSettings),
  );

export const getLocalStorageOploggTodoTabsSettings = (): string[] =>
  JSON.parse(
    localStorage.getItem("oploggTodoTabsSettings") ??
      JSON.stringify(["oplogg"]),
  );

export const setLocalStorageVehicleAffectedSidePanelSettings = (
  VehicleAffectedSidePanelSettings: boolean,
) =>
  localStorage.setItem(
    "VehicleAffectedSidePanelSettings",
    JSON.stringify(VehicleAffectedSidePanelSettings),
  );

export const getLocalStorageVehicleAffectedSidePanelSettings = (): boolean =>
  JSON.parse(
    localStorage.getItem("VehicleAffectedSidePanelSettings") ??
      JSON.stringify(true),
  );

function keyForMeasureProgressRushState(incidentId: string): string {
  return `measureProgress:isRush:${incidentId}`;
}

export function setLocalStorageMeasureProgressRushState(
  incidentId: string,
  value: boolean,
): void {
  localStorage.setItem(
    keyForMeasureProgressRushState(incidentId),
    JSON.stringify(value),
  );
}

export function getLocalStorageMeasureProgressRushState(
  incidentId: string,
): boolean {
  const storedValue = localStorage.getItem(
    keyForMeasureProgressRushState(incidentId),
  );

  if (isNotNullish(storedValue)) {
    return JSON.parse(storedValue);
  }

  return false;
}
